import { createFileRoute } from '@tanstack/react-router';
import { ApprovalsInboxPage } from '@/features/purchasing/ApprovalsInbox';
export const Route = createFileRoute('/_dashboard/dashboard/purchasing/approvals')({
  component: ApprovalsInboxPage,
});
